﻿$.fn.dxCtrlJauge = function custom_dxCtrlJauge(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrljauge dx-ctrl");
        this.createInstance(new cdxCtrlJauge(this, option));
    }
    return this;
}

window.cdxCtrlJauge = function (container, option) {
    var Me = this;
    if (typeof option.value == 'undefined') option.value = null;
    if (typeof option.name == 'undefined') option.name = "";
    if (typeof option.type == 'undefined') option.type = parametre.typeJauge;
    if (typeof option.opacity == 'undefined') option.opacity = 0.8;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            if (name == "message") {
                if (typeof option.message != 'undefined' && option.message != null) {
                    if (typeof option.message === 'function') { option.message($DivMessage) }
                    else { $DivMessage.html(option.message) }
                } else {
                    if (progressBar) {
                        progressBar.element().remove()
                        progressBar = null
                    }
                    $DivMessage.empty()
                }
            }
            if (name == "onCancel") {
                if (typeof option.onCancel != 'undefined') {
                    if (option.onCancel == null) {
                        $DivBtCancel.hide();
                    } else {
                        $DivBtCancel.show();
                    }
                }
            }//$DivMessage.html(option[name])
            //switch (name) {
            //    case "message": $DivMessage.html(option.message); break;
            //}
        }
    }

    var ElemParent = null;
    var $DivJaugeShading = null
    var $DivMaitre = null;
    var $DivFirst = null;
    var $DivSecond = null;
    var $DivTrois = null;
    this.$DivTitle = null;
    var $DivProgress = null;
    var $DivMessage = null;
    var $DivBtCancel = null;
    function mConstruit() {
        container.empty();
        ElemParent = container.parent();
        ElemParent.css("position", "relative")
    }

    //this.isVisible = function () {
    //    container.is(':visible')
    //}

    this.isCanceled = false
    var $imgBackground = null;
    function mConstruitJauge() {
        this.isCanceled = false
        if ($imgBackground) $imgBackground.remove();
        var zindex = mGetMaxZindex()
        $DivJaugeShading = $("<div style='width:100%;height:100%;border:none;position:absolute;top:0;left:0;opacity:" + option.opacity + ";z-index:" + (zindex + 1) + ";display:none;' class='dx-theme-material-typography JAUGESHADING'/>").appendTo(container);
        //$DivJaugeShading.css("z-index", mGetMaxZindex() + 1);
        if (option.isJaugeDemarrage) {
            $DivJaugeShading.css({ "background-color": "#363640", "opacity": "1" });
            $imgBackground = $("<img src='' style='position:absolute;top:10000px;right:10000px;z-index:-1;opacity:0.3;width:300px;' class='imgarrplan'/>").appendTo($DivJaugeShading);
            $imgBackground.on("load", function () {
                $imgBackground.css({
                    top: "calc(50% - " + $imgBackground.innerHeight() / 2 + "px)",
                    left: "calc(50% - " + $imgBackground.innerWidth() / 2 + "px)"
                });
            });
            $imgBackground.attr("src", parametre.img);
            //$("<div style='position:absolute;bottom:0;left:0;z-index:10;'>").appendTo($DivJaugeShading).text($(location).attr("href"))
        }
        else {
            if (option.classShading != 'undefined') $DivJaugeShading.addClass(option.classShading);
            if (option.opacityShading != 'undefined') $DivJaugeShading.css("opacity", option.opacityShading);
        }
        switch (option.type) {
            case "clock":
                $DivFirst = $('<div class="cssload-clock dx-state-focused.dx-gallery dx-gallery-indicator-item-selected dx-theme-accent-as-border-color" style="position:absolute;top:calc(50% - 50px);left:calc(50% - 50px);z-index:' + (zindex + 2) + ';"></div>').appendTo(container);
                //if (option.isJaugeDemarrage) { $DivFirst.css("background", "#FF5722"); $DivFirst.css("border-color", "#FF5722"); }
                break;
            case "double_rond":
                $DivFirst = $('<div class="loaderdoublerond" style="position:absolute;top:calc(50% - 50px);left:calc(50% - 50px);z-index:' + (zindex + 2) + ';"></div>').appendTo(container);
                $DivSecond = $("<div class='cssload-loader dx-state-focused.dx-gallery dx-gallery-indicator-item-selected'></div>").appendTo($DivFirst)
                //if (option.isJaugeDemarrage) $DivSecond.css("background-color", "#FF5722");
                break;
            case "multi_carre":
                if (typeof option.width == 'undefined') option.width = 100
                if (typeof option.height == 'undefined') option.height = 100
                $DivFirst = $('<div class="loadermulticarre" translate="no" style="position:absolute;top:calc(50% - ' + option.height / 2 + 'px);left:calc(50% - ' + (option.width / 2 + 10) + 'px);z-index:' + (zindex + 2) + ';display:none;width:' + option.width + 'px;height:' + option.height + 'px;"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>').appendTo(container);
                $DivFirst.children().addClass("dx-state-focused.dx-gallery dx-gallery-indicator-item-selected");
                //if (option.isJaugeDemarrage) $DivFirst.children().css("background-color", "#FF5722");
                break;
            case "carre_tourne":
                $DivFirst = $("<div class='loadercarretourne dx-theme-accent-as-border-color' style='position:absolute;top:calc(50% - 50px);left:calc(50% - 50px);z-index:" + (zindex + 2) + ";'/>").appendTo(container)
                $DivSecond = $("<div class='shadowcarretourne'></div>").appendTo($DivFirst)
                $DivTrois = $("<div class='boxcarretourne dx-state-focused.dx-gallery dx-gallery-indicator-item-selected'></div>").appendTo($DivFirst)
                //if (option.isJaugeDemarrage) { $DivTrois.css("background-color", "#FF5722"); $DivTrois.css("fill", "#FF5722"); }
                break;
            case "carre":
                $DivFirst = $("<span class='loader dx-theme-accent-as-border-color' style='position:absolute;top:calc(50% - 50px);left:calc(50% - 50px);z-index:" + (zindex + 2) + ";'/>").appendTo(container)
                $DivSecond = $("<span class='loader-inner dx-theme-accent-as-background-color' style='z-index:6'/>").appendTo($DivFirst)
                //if (option.isJaugeDemarrage) $DivFirst.css("border-color", "#FF5722");
                //if (option.isJaugeDemarrage) { $DivSecond.css("background-color", "#FF5722"); $DivSecond.css("fill", "#FF5722"); }
                break;
        }
        var $DivTot = $("<div style='position:absolute;z-index:" + (zindex + 2) + ";top:calc(50% + " + option.height + "px);width:100%;left:0;text-align:center;'/>").appendTo(container)
        Me.$DivTitle = $("<div style='font-size:150%;font-variant:small-caps;'/>").appendTo($DivTot)
        $DivProgress = $("<div style='width:100%;max-width:250px;display:inline-block;' class='jaugeprogressbar'/>").appendTo($DivTot)
        $DivMessage = $("<div/>").appendTo($DivTot)
        if (typeof option.message != 'undefined' && option.message != null) {
            if (typeof option.message === 'function') { option.message($DivMessage) }
            else { $DivMessage.html(option.message) }
        }
        $DivBtCancel = $("<div style='display:none'/>").appendTo($DivTot)

        //if (typeof option.onCancel != 'undefined' && option.onCancel) {
        $("<div style='margin-top:10px;'/>").appendTo($DivBtCancel).dxCtrlButton({
            text: "Annuler",
            onClick: function (e) {
                Me.isCanceled = true;
                $DivBtCancel.hide();
                if (typeof option.onCancel != 'undefined' && option.onCancel) option.onCancel(e);
            }
        })
        if (typeof option.onCancel != 'undefined' && option.onCancel) $DivBtCancel.show();
        //}
    }
    function mRemoveJauge() {
        container.empty()
        progressBar = null;
        option.onCancel = null;
    }

    this.mChangeTaille = function (taille) { $DivFirst.css({ width: taille + "px", height: taille + "px" }); }
    this.mChangeTopJauge = function (top) { $DivFirst.css({ top: top + "px" }); }

    this.isVisible = false;
    var timeoutShowTempo = null;
    this.mShowTempo = function (tempo) {
        if (typeof tempo == 'undefined') tempo = 300
        if (timeoutShowTempo) window.clearTimeout(timeoutShowTempo);
        timeoutShowTempo = window.setTimeout(function () { Me.mShow(); }, tempo);
    }
    this.mShow = function (tempo, callBack) {
        console.log("showjauge")
        if (this.isVisible) return
        this.isCanceled = false;
        this.isVisible = true;
        //$DivJaugeShading.stop()
        //$DivFirst.stop()
        mConstruitJauge();
        if (timeoutShowTempo) window.clearTimeout(timeoutShowTempo);
        if (typeof tempo == 'undefined' || tempo == null) {
            if (typeof option.shading == 'undefined' || option.shading) $DivJaugeShading.show();
            $DivFirst.show()
            if (typeof callBack != 'undefined') callBack();
            //$DivFirst.show(0, function () {
            //    if (typeof callBack != 'undefined')
            //        window.setTimeout(function () { callBack(); }, 0)
            //})
        } else {
            if (typeof option.shading == 'undefined' || option.shading) $DivJaugeShading.fadeIn((typeof tempo == 'undefined') ? 100 : tempo);
            $DivFirst.fadeIn(((typeof tempo == 'undefined') ? 100 : tempo), "swing", function () { if (typeof callBack != 'undefined') callBack(); });
        }
    }
    this.mHide = function (tempo) {
        option.onCancel = null
        option.message = null
        if (timeoutShowTempo) window.clearTimeout(timeoutShowTempo);
        if (!$DivJaugeShading) return;
        if (typeof tempo == 'undefined' || tempo == null) {
            $DivJaugeShading.css({ "opacity": "0.8" });
            mRemoveJauge();
            Me.isVisible = false;
            $DivFirst.fadeOut()
        } else {
            $DivJaugeShading.fadeOut(((typeof tempo == 'undefined') ? 100 : tempo), "swing", ((option.isJaugeDemarrage) ? function () {
                $DivJaugeShading.css({ "opacity": "0.8" });
                mRemoveJauge();
                Me.isVisible = false;
            } : function () {
                mRemoveJauge();
            }));
            $DivFirst.fadeOut((typeof tempo == 'undefined') ? 100 : tempo);
        }

        if (option.isJaugeDemarrage) {
            container.css("background-color", "transparent");
            this.option("onCancel", null)
            this.option("message", null)
            option.isJaugeDemarrage = false;
        }
    }

    var progressBar = null;
    var dateDebut = null
    // ---- À déclarer au même niveau que progressBar / dateDebut ----
    var ema = { vitesse: null, dernierT: null, dernierePos: 0, nbMesures: 0, total: null };
    var EMA_ALPHA = 0.15; // 0.05 = très lisse, 0.3 = très réactif

    function emaReset(position, total) {
        ema.vitesse = null;
        ema.dernierT = Date.now();
        ema.dernierePos = position;
        ema.nbMesures = 0;
        ema.total = total;
    }

    function emaMaj(position, total) {
        // Nouveau traitement (total différent ou position qui recule) → on repart à zéro
        if (ema.dernierT === null || total !== ema.total || position < ema.dernierePos) {
            emaReset(position, total);
            return;
        }
        if (position > ema.dernierePos) {
            var now = Date.now();
            var msParElem = (now - ema.dernierT) / (position - ema.dernierePos);
            ema.vitesse = (ema.vitesse === null)
                ? msParElem
                : EMA_ALPHA * msParElem + (1 - EMA_ALPHA) * ema.vitesse;
            ema.nbMesures++;
            ema.dernierT = now;
            ema.dernierePos = position;
        }
    }

    function formatRestant(ms) {
        var s = Math.round(ms / 1000);
        var h = Math.floor(s / 3600);
        var m = Math.floor((s % 3600) / 60);
        var sec = s % 60;
        var txt = "";
        if (h > 0) txt += h + "h";
        if (h > 0 || m > 0) txt += String(m).padStart(h > 0 ? 2 : 1, '0') + "mn";
        txt += String(sec).padStart(2, '0') + "s";
        return txt;
    }
    // ----------------------------------------------------------------

    this.mAvance = function (message, position, total) {
        if (typeof option.onCancel != 'undefined' && option.onCancel) $DivBtCancel.show();

        var iPos = parseInt(position) || 0;
        var iTot = parseInt(total) || 100;

        if (!progressBar || progressBar.element().closest("body").length == 0) {
            emaReset(iPos, iTot);
            progressBar = $("<div style='padding-top:10px;'/>").appendTo($DivProgress).dxProgressBar({
                min: 0,
                max: iTot,
                value: iPos,
                width: "100%"
            }).dxProgressBar("instance");

            progressBar.option("statusFormat", function (ratio, value) {
                if (message == null) return "";
                if (isNaN(ratio)) return "";
                var max = progressBar.option("max");
                var tot = "";
                if (ema.nbMesures >= 3 && ema.vitesse !== null) {
                    tot = " - Reste " + formatRestant(ema.vitesse * (max - value));
                }
                return parseInt(ratio * 100) + "% (" + value + "/" + max + ")" + tot;
            });
            progressBar.element().find(".dx-progressbar-status").css("float", "none");
        } else {
            emaMaj(iPos, iTot);              // AVANT de changer value : statusFormat s'en sert
            progressBar.option("max", iTot);
            progressBar.option("value", iPos);
        }

        if (typeof message != 'undefined' && message != null) {
            if (typeof message === 'function') { message($DivMessage) }
            else { $DivMessage.html(message) }
        }
    }

    this.element = function () { return container; }

    mConstruit();
}


//$.fn.dxCtrlJauge = function custom_dxCtrlJauge(option) {
//    if (option == "instance") {
//        return this.instance;
//    }
//    else {
//        this.addClass("dx-ctrljauge");
//        this.instance = new cdxCtrlJauge(this, option);
//    }
//    return this;
//}

//function cdxCtrlJauge(container, option) {
//    var Me = this;
//    if (typeof option.value == 'undefined') option.value = null;
//    if (typeof option.name == 'undefined') option.name = "";
//    if (typeof option.type == 'undefined') option.type = parametre.typeJauge;
//    if (typeof option.opacity == 'undefined') option.opacity = 0.8;

//    this.option = function (name, value) {
//        if (typeof value == 'undefined') {
//            return option[name];
//        }
//        else {
//            option[name] = value;
//        }
//    }

//    var ElemParent = null;
//    var $DivJaugeShading = null
//    var $DivMaitre = null;
//    var $DivFirst = null;
//    var $DivSecond = null;
//    var $DivTrois = null;
//    function mConstruit() {
//        container.empty();
//        ElemParent = container.parent();
//        ElemParent.css("position", "relative")
//        $DivMaitre = $("<div style='display:none;width:100%;height:100%;border:none;position:absolute;top:0;left:0;background-color:transparent;text-align:center;vertical-align:calc(50% - 100px);z-index:500' class='dx-theme-material-typography JAUGE" + option.name + "'/>").appendTo(container);
//        if (option.isJaugeDemarrage) $DivMaitre.css("background-color", "#363640");
//        $DivJaugeShading = $("<div style='width:100%;height:100%;border:none;position:absolute;top:0;left:0;opacity:" + option.opacity + ";z-index:5;' class='dx-theme-material-typography JAUGESHADING'/>").appendTo($DivMaitre);
//        if (typeof option.shading != 'undefined' && !option.shading) $DivJaugeShading.css("display", "none");
//        switch (option.type) {
//            case "clock":
//                $DivFirst = $('<div class="cssload-clock dx-state-focused.dx-gallery dx-gallery-indicator-item-selected dx-theme-accent-as-border-color" style="z-index:6;"></div>').appendTo($DivMaitre);
//                if (option.isJaugeDemarrage) { $DivFirst.css("background", "#FF5722"); $DivFirst.css("border-color", "#FF5722"); }
//                break;
//            case "double_rond":
//                $DivFirst = $('<div class="loaderdoublerond" style="z-index:6;"></div>').appendTo($DivMaitre);
//                $DivSecond = $("<div class='cssload-loader dx-state-focused.dx-gallery dx-gallery-indicator-item-selected'></div>").appendTo($DivFirst)
//                if (option.isJaugeDemarrage) $DivSecond.css("background-color", "#FF5722");
//                break;
//            case "multi_carre":
//                $DivFirst = $('<div class="loadermulticarre" translate="no" style="position:absolute;top:calc(50% - 100px);left:calc(50% - 100px);z-index:6;"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>').appendTo($DivMaitre);
//                $DivFirst.children().addClass("dx-state-focused.dx-gallery dx-gallery-indicator-item-selected");
//                if (option.isJaugeDemarrage) $DivFirst.children().css("background-color", "#FF5722");
//                break;
//            case "carre_tourne":
//                $DivFirst = $("<div class='loadercarretourne dx-theme-accent-as-border-color' style='z-index:6;'/>").appendTo($DivMaitre)
//                $DivSecond = $("<div class='shadowcarretourne'></div>").appendTo($DivFirst)
//                $DivTrois = $("<div class='boxcarretourne dx-state-focused.dx-gallery dx-gallery-indicator-item-selected'></div>").appendTo($DivFirst)
//                if (option.isJaugeDemarrage) { $DivTrois.css("background-color", "#FF5722"); $DivTrois.css("fill", "#FF5722"); }
//                break;
//            case "carre":
//                $DivFirst = $("<span class='loader dx-theme-accent-as-border-color' style='z-index:6;top:calc(50% - 39px)'/>").appendTo($DivMaitre)
//                $DivSecond = $("<span class='loader-inner dx-theme-accent-as-background-color' style='z-index:6'/>").appendTo($DivFirst)
//                if (option.isJaugeDemarrage) $DivFirst.css("border-color", "#FF5722");
//                if (option.isJaugeDemarrage) { $DivSecond.css("background-color", "#FF5722"); $DivSecond.css("fill", "#FF5722"); }
//                break;
//        }
//    }

//    this.mChangeTaille = function (taille) { $DivFirst.css({ width: taille + "px", height: taille + "px" }); }
//    this.mChangeTopJauge = function (top) { $DivFirst.css({ top: top + "px" }); }

//    this.mShow = function (tempo) {
//        $DivMaitre.fadeIn((typeof tempo == 'undefined') ? 100 : tempo);
//    }
//    this.mHide = function (tempo) {
//        $DivMaitre.fadeOut((typeof tempo == 'undefined') ? 100 : tempo);
//        if (option.isJaugeDemarrage) {
//            $DivMaitre.css("background-color", "transparent");
//            switch (option.type) {
//                case "carre":
//                    if ($DivFirst) $DivFirst.css("border-color", "");
//                    if ($DivSecond) $DivSecond.css("background-color", "transparent");
//                    if ($DivSecond) $DivSecond.css("fill", "");
//                    opacity = "0.8";
//                    $DivJaugeShading.css("opacity", ((typeof opacity == 'undefined') ? "0.8" : opacity));
//                    break;
//                case "carre_tourne":
//                    $DivTrois.css("background-color", ""); $DivTrois.css("fill", "");
//                    break;
//                case "multi_carre":
//                    $DivFirst.children().css("background-color", "");
//                    break;
//                case "clock":
//                    $DivFirst.css("background", "");
//                    $DivFirst.css("border-color", "");
//                    break;
//                case "double_rond":
//                    $DivSecond.css("background-color", "");
//                    break;
//            }
//            option.isJaugeDemarrage = false;
//        }
//    }
//    this.element = function () { return $DivMaitre; }

//    mConstruit();
//}